<template>
  <div class="flex justify-end">
        <a :href="`/panels/floors/${uuid}`" class="mr-2">
            <button-secondary>
                <template slot="icon"><i class="fa fa-television"></i></template>
                Monitor anzeigen
            </button-secondary>
        </a>
    </div>
</template>

<script>
import ButtonSecondary from "../components/UI/ButtonSecondary";
export default {
    name: "FloorPanelSelect",
    components: {
        ButtonSecondary
    },

    props: ['uuid'],

}
</script>